import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {AppComponent} from './app.component'; 
import { LoginComponent } from './components/autenticacion/login/login.component';
import { UsuariosComponent } from './administracion/usuarios/usuarios.component';
import { ConfiguracionCreditosComponent } from './administracion/configurar-creditos/configurar-creditos.component';
//Creditos
import { CreditosComponent } from './creditos/creditos.component';
import { ListadoCreditosComponent } from './creditos/listado/listado-creditos.component';
import { TablaAmortizacionComponent } from './creditos/tabla-amortizacion/tabla-amortizacion.component';
//Hipotecario
import { CreditosHipotecarioSimulacionComponent } from './creditos/hipotecario/simulacion/creditos-hipotecario-simulacion.component';
import { HipoteacrioDetallesComponent } from './creditos/hipotecario/detalles/hipotecario-detalles.component';
//Automotriz 
import { AutomotrizSimuladorComponent } from './creditos/automotriz/simulador/automotriz-simulador.component';
import { AutomotrizDetallesComponent } from './creditos/automotriz/detalles/automotriz-detalles.component';
//Prendario
import { PrendarioSimuladorComponent } from './creditos/prendario/simulador/prendario-simulador.component';
import { PrendarioDetallesComponent } from './creditos/prendario/detalles/prendario-detalles.component';
//Personal
import { PersonalSimuladorComponent } from './creditos/personal/simulador/personal-simulador.component';
import { PersonalDetallesComponent } from './creditos/personal/detalles/personal-detalles.component';
//Verde
import { VerdeSimuladorComponent } from './creditos/verde/simulador/verde-simulador.component';
import { VerdeDetallesComponent } from './creditos/verde/detalles/verde-detalles.component';
//Credigas carburación
import { CarburacionSimuladorComponent } from './creditos/crediga-carburacion/simulador/carburacion-simulador.component';
import { CarburacionDetallesComponent } from './creditos/crediga-carburacion/detalles/carburacion-detalles.component';
//Credigas estacionario
import { EstacionarioSimuladorComponent } from './creditos/credigas-estacionario/simulador/estacionario-simulador.component';
import { EstacionarioDetallesComponent } from './creditos/credigas-estacionario/detalles/estacionario-detalles.component';
//Nomina
import { NominaSimuladorComponent } from './creditos/nomina/simulador/nomina-simulador.component';
import { NominaDetallesComponent } from './creditos/nomina/detalles/nomina-detalles.component';
//Comercializacion
import { ComercialSimuladorComponent } from './creditos/comercializacion/simulador/comercial-simulador.component';
import { ComercialDetallesComponent } from './creditos/comercializacion/detalles/comercial-detalles.component';
//Clientes
import { ClientesDetallesComponent } from './clientes/detalles/clientes-detalles.component';
//Convenios
import { ConveniosDetallesComponent } from './convenios/detalles/convenios-detalles.component';
import { ConveniosListadoComponent } from './convenios/listado/convenios-listado.component';
import { ConveniosPagosMultiplesComponent } from './convenios/pagos-multiples/convenios-pagos-multiples.component';
//Promotores
import { PromotoresListadoComponent } from './promotores/listado/promotores-listado.component';
//Reportes
import { ReportesListadoComponent } from './reportes/listado/reportes-listado.component';
import { ReporteConcentradosComponent } from './reportes/concentrados/reporte-concentrados.component';
import { ReporteColocadosComponent } from './reportes/creditos-colocados/reporte-colocados.component';
import { ReportePagosComponent } from './reportes/pagos/reporte-pagos.component';
import { CarteraGeneralComponent } from './reportes/cartera/general/cartera-general.component';
import { CarteraCreditosComponent } from './reportes/cartera/creditos/cartera-creditos.component';
import { ReporteCobranzaNominaComponent } from './reportes/cobranza/nomina/reporte-cobranza-nomina.component';
import { ReporteCobranzaGeneralComponent } from './reportes/cobranza/general/reporte-cobranza-general.component';
import { ReporteClientesGeneralComponent } from './reportes/clientes/general/reporte-clientes-general.component';
import { ReporteConveniosGeneralComponent } from './reportes/convenios/general/reporte-convenios-general.component';
import { ReportePagosPenalizacionesComponent } from './reportes/pagos/penalizaciones/reporte-pagos-penalizaciones.component';
import { ReportePromotoresGeneralComponent } from './reportes/promotores/general/reporte-promotores-general.component';
import { SucursalesComponent } from './administracion/sucursales/sucursales.component';
import { GastosComponent } from './gastos/gastos.component';

import { RolGuard } from './services/rol.guard';
import { CategoriasGastosComponent } from './administracion/categorias-gastos/categorias-gastos.component';
import { SubcategoriasGastosComponent } from './administracion/categorias-gastos/subcategorias-gastos/subcategorias-gastos.component';
import { GastosCategoriaComponent } from './gastos/gastos-categoria/gastos-categoria.component';
import { GastosDetalladosComponent } from './gastos/gastos-detallados/gastos-detallados.component';
import { GastosDetalladosMesComponent } from './gastos/gastos-detallados-mes/gastos-detallados-mes.component';
import { GastosDetalladosCategoriaComponent } from './gastos/gastos-detallados-categoria/gastos-detallados-categoria.component';

//Fondeadores
import { FondeadoresComponent } from './administracion/fondeadores/fondeadores.component';
import { RegistroFondeadorComponent } from './administracion/fondeadores/registro-fondeador/registro-fondeador.component';
import { ProductosFinancierosComponent } from './administracion/productos-financieros/productos-financieros.component';
import { PerfilFondeadorComponent } from './administracion/fondeadores/perfil-fondeador/perfil-fondeador.component';
import { EmpresasComponent } from './administracion/empresas/empresas.component';
import { DetallesInversionComponent } from './administracion/fondeadores/detalles-inversion/detalles-inversion.component';
import { ModuloVistaComponent } from './modulo-vista/modulo-vista.component';
import { RegistroSocioFondeadorComponent } from './modulo-vista/registro-socio-fondeador/registro-socio-fondeador.component';
import { PerfilSocioFondeadorComponent } from './modulo-vista/perfil-socio-fondeador/perfil-socio-fondeador.component';
import { ReporteriaComponent } from './administracion/fondeadores/reporteria/reporteria.component'
import { FondeosComponent } from './administracion/fondeadores/reporteria/fondeos/fondeos.component'
import { RendimientosAPagarComponent } from './administracion/fondeadores/reporteria/rendimientos-a-pagar/rendimientos-a-pagar.component'; 
import { RendimientosPagadosComponent } from './administracion/fondeadores/reporteria/rendimientos-pagados/rendimientos-pagados.component'; 
import { DevolucionesFondeoComponent } from './administracion/fondeadores/reporteria/devoluciones-fondeo/devoluciones-fondeo.component'; 
import { SaldoFondeadoresComponent } from './administracion/fondeadores/reporteria/saldo-fondeadores/saldo-fondeadores.component';
const appRoutes:Routes = [

	{ path: 'login', component: LoginComponent },
	{ path: '', component: ListadoCreditosComponent },
	//Admin
	{ path: 'usuarios', component: UsuariosComponent },
	{ path: 'configurar-creditos', component: ConfiguracionCreditosComponent },
	{ path: 'sucursales', component: SucursalesComponent },
	{ path: 'categorias-gastos', component: CategoriasGastosComponent },
	{ path: 'subcategorias-gastos/:id', component: SubcategoriasGastosComponent },
	{ path: 'empresas', component: EmpresasComponent },
	//Créditos
	{ path: 'creditos', component: ListadoCreditosComponent },
	{ path: 'creditos/nuevo', component: CreditosComponent },
	{ path: 'creditos/tabla-amortizacion/:id', component: TablaAmortizacionComponent },
	//Hipotecario
	{ path: 'creditos/hipotecario/simulacion', component: CreditosHipotecarioSimulacionComponent },
	{ path: 'creditos/hipotecario/simulacion/:id', component: CreditosHipotecarioSimulacionComponent },
	{ path: 'creditos/hipotecario/detalles/:id', component: HipoteacrioDetallesComponent },
	//Automotriz
	{ path: 'creditos/automotriz/simulador', component: AutomotrizSimuladorComponent },
	{ path: 'creditos/automotriz/simulador/:id', component: AutomotrizSimuladorComponent },
	{ path: 'creditos/automotriz/detalles/:id', component: AutomotrizDetallesComponent },
	//Prendario
	{ path: 'creditos/prendario/simulador', component: PrendarioSimuladorComponent },
	{ path: 'creditos/prendario/simulador/:id', component: PrendarioSimuladorComponent },
	{ path: 'creditos/prendario/detalles/:id', component: PrendarioDetallesComponent },
	//Personal
	{ path: 'creditos/personal/simulador', component: PersonalSimuladorComponent },
	{ path: 'creditos/personal/simulador/:id', component: PersonalSimuladorComponent },
	{ path: 'creditos/personal/detalles/:id', component: PersonalDetallesComponent },
	//Verde
	{ path: 'creditos/verde/simulador', component: VerdeSimuladorComponent },
	{ path: 'creditos/verde/simulador/:id', component: VerdeSimuladorComponent },
	{ path: 'creditos/verde/detalles/:id', component: VerdeDetallesComponent },
	//Credigas carburación
	{ path: 'creditos/carburacion/simulador', component: CarburacionSimuladorComponent },
	{ path: 'creditos/carburacion/simulador/:id', component: CarburacionSimuladorComponent },
	{ path: 'creditos/carburacion/detalles/:id', component: CarburacionDetallesComponent },
	//Credigas estacionario
	{ path: 'creditos/estacionario/simulador', component: EstacionarioSimuladorComponent },
	{ path: 'creditos/estacionario/simulador/:id', component: EstacionarioSimuladorComponent },
	{ path: 'creditos/estacionario/detalles/:id', component: EstacionarioDetallesComponent },
	//+ Pension
	{ path: 'creditos/pluspension/simulador', component: EstacionarioSimuladorComponent },
	{ path: 'creditos/pluspension/simulador/:id', component: EstacionarioSimuladorComponent },
	{ path: 'creditos/pluspension/detalles/:id', component: EstacionarioDetallesComponent },
	//Nomina
	{ path: 'creditos/nomina/simulador', component: NominaSimuladorComponent },
	{ path: 'creditos/nomina/simulador/:id', component: NominaSimuladorComponent },
	{ path: 'creditos/nomina/detalles/:id', component: NominaDetallesComponent },
	//Meses sin intereses
	{ path: 'creditos/comercializacion/simulador', component: ComercialSimuladorComponent },
	{ path: 'creditos/comercializacion/simulador/:id', component: ComercialSimuladorComponent },
	{ path: 'creditos/comercializacion/detalles/:id', component: ComercialDetallesComponent },
	//Clientes
	{ path: 'clientes/detalles/:id', component: ClientesDetallesComponent },
	//Convenios
	{ path: 'convenios/detalles', component: ConveniosDetallesComponent },
	{ path: 'convenios/detalles/:id', component: ConveniosDetallesComponent },
	{ path: 'convenios/pagos-multiples/:idConvenios', component: ConveniosPagosMultiplesComponent },
	{ path: 'convenios', component: ConveniosListadoComponent },
	//Promotores
	{ path: 'promotores', component: PromotoresListadoComponent },
	//Gastos
	{ path: 'gastos', component: GastosComponent },
	{ path: 'gastos/categoria/:id/:mes', component: GastosCategoriaComponent },
	{ path: 'gastos/categoria/:id/:mes/:idSucursal', component: GastosCategoriaComponent },
	{ path: 'gastos/detalles/:tipo/:id/:mes', component: GastosDetalladosComponent },
	{ path: 'gastos/detalles/:tipo/:id/:mes/:idSucursal', component: GastosDetalladosComponent },
	{ path: 'detalle-gastos-mes/:mes/:idSucursal', component: GastosDetalladosMesComponent },
	{ path: 'detalle-gastos-mes/:mes', component: GastosDetalladosMesComponent },
	{ path: 'detalle-gastos-categoria', component: GastosDetalladosCategoriaComponent },
	//Fondeadores
	{ path: 'fondeadores', component: FondeadoresComponent },
	{ path: 'fondeadores/registro-fondeador', component: RegistroFondeadorComponent },
	{ path: 'fondeadores/registro-fondeador/:idFondeador', component: RegistroFondeadorComponent },
	{ path: 'socio/registro-fondeador/:idSocio', component: RegistroFondeadorComponent },
	{ path: 'productos-financieros', component: ProductosFinancierosComponent },
	{ path: 'fondeadores/perfil-fondeador/:idFondeador', component: PerfilFondeadorComponent },
	{ path: 'fondeadores/detalles-inversion/:idFondeador/:idEsquemaInversion', component: DetallesInversionComponent },
	// { path: 'fondeador/reporteria', component: ReporteriaComponent },
	// Reportes Fondeador
	{ path: 'fondeador/reporteria', canActivate:[RolGuard] ,children:[
		{ path: '', component: ReporteriaComponent },
		{ path: 'saldo-fondeadores', component: SaldoFondeadoresComponent },
		{ path: 'fondeos', component: FondeosComponent },
		{ path: 'devoluciones-fondeos', component: DevolucionesFondeoComponent },
		{ path: 'pagados', component: RendimientosPagadosComponent },
		{ path: 'a-pagar', component: RendimientosAPagarComponent },
	]},
	//Modulo de vista
	{ path: 'modulo-vista', component: ModuloVistaComponent },
	{ path: 'registrar/socio-fondeador', component: RegistroSocioFondeadorComponent },
	{ path: 'registrar/socio-fondeador/:idSocio', component: RegistroSocioFondeadorComponent },
	{ path: 'perfil-socio/:idSocio', component: PerfilSocioFondeadorComponent },
	//Reportes
	{ path: 'reportes', canActivate:[RolGuard] ,children:[
		{ path: '', component: ReportesListadoComponent },
		{ path: 'concentrado', component: ReporteConcentradosComponent },
		{ path: 'colocados', component: ReporteColocadosComponent },
		{ path: 'colocados/:credito', component: ReporteColocadosComponent },
		{ path: 'pagos', component: ReportePagosComponent },
		{ path: 'cartera', component: CarteraGeneralComponent },
		{ path: 'cartera/detalles', component: CarteraCreditosComponent },
		{ path: 'cartera/credito/:credito', component: CarteraCreditosComponent },
		{ path: 'cobranza/nomina', component: ReporteCobranzaNominaComponent },
		{ path: 'cobranza/general', component: ReporteCobranzaGeneralComponent },
		{ path: 'clientes', component: ReporteClientesGeneralComponent },
		{ path: 'convenios', component: ReporteConveniosGeneralComponent },
		{ path: 'penalizaciones', component: ReportePagosPenalizacionesComponent },
		{ path: 'promotores', component: ReportePromotoresGeneralComponent }
	] },
];

export const appRoutingProviders: any[] = [];
export const routing:ModuleWithProviders = RouterModule.forRoot(appRoutes, { useHash: true });


// WEBPACK FOOTER //
// ./src/app/app.routing.ts